import { Injectable } from '@angular/core';
import { BaseService } from '@core/service/base.service';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PlantService extends BaseService{

  constructor(http:HttpClient) {
    super(http)
  }

  getUrl(): string {
    return "api/plant";
  }





}
